
    <ng-container *ngIf="element.children.length > 0">
      <ng-container *ngFor="let elementChild of element.children">
        <app-form-element
          [(actionParams)]="actionParams"
          [(selectedElement)]="selectedElement"
          [(showDialogAddAddress)]="showDialogAddAddress"
          [form]="form"
          [formGroup]="formGroup"
          [element]="elementChild"
          [moduleElement]="moduleElement"
          [entity]="entity"
          [editMode]="editMode"
        ></app-form-element>
      </ng-container>
  </ng-container>
  